let confirmedReason = null;
export const setConfirmedReason = (reason) => { confirmedReason = reason || null; };
export const consumeConfirmedReason = () => { const value = confirmedReason; confirmedReason = null; return value; };
export const clearConfirmedReason = () => { confirmedReason = null; };
